module.exports = __webpack_public_path__ + "img/ISO20000-en.b248039f.jpg";